import React from 'react'
import './popular.css'
import Post from './Post'
import data from '../FakeData/index.json'
import UseFetch from '../UseFetch'
import mainData from '../FetchDataLinks'
import PostSkeleton from './PostSkeleton'

function PopularPosts() {

    let a = 0;

    const { blogs, loading } = UseFetch(mainData.popular)

    return (
        <div className="w3l-homeblock3 py-5">
            <div className="container py-lg-5 py-md-4">
                <h3 className="section-title-left mb-4"> Most Loved Blogs on {data[0].name} </h3>
                <div className="row top-pics">
                    {loading && Array(3).fill().map(() => {
                        a++;
                        return <PostSkeleton key={`popularPostSkeleton${a}`} />
                    })}
                    {!loading && blogs.map((blog) => {
                        return <Post key={blog.id} slug={blog.slug} image={blog.Image} PostHead={blog.Headline} date={blog.date} time={blog.Time} authorName={data[0].authorName} />
                    })}
                </div>
            </div>
        </div>

    )
}

export default PopularPosts
